<template>
  <div>
    <v-main>
      <v-container fluid>
        <v-card
          class="pt-3 pb-6"
          :class="$vuetify.breakpoint.smAndUp ? 'px-4' : 'px-2'"
        >
          <v-row>
            <v-col cols="12">
              <p class="text-h5 mb-n2">จัดการระบบ</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-row class="ml-1 ">
                  <v-col cols="6">
                    <v-text-field
                      label="ค้นหาระบบ"
                      outlined
                      dense
                      hide-details=""
                      class="align-center"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-btn elevation="2" color="primary">
                      <v-icon> mdi-magnify </v-icon>ค้นหา</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                elevation="2"
                @click="dialogAdd = true"
                color="success"
                class="float-right"
              >
                <v-icon> mdi-plus </v-icon>เพิ่มชื่อระบบ</v-btn
              >
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="ReqEventList"
                :items-per-page="-1"
                class="elevation-1"
                hide-default-footer
              >
                <template #body="props">
                  <Draggable v-model="ReqEventList" tag="tbody">
                    <tr
                      v-for="(rowIndex1, index) in props.items"
                      :key="rowIndex1"
                    >
                      <td class="justify-center">
                        <div v-if="index != 0">
                          <v-btn text icon @click="upData(index)"
                            ><v-icon>mdi-chevron-up</v-icon></v-btn
                          >
                        </div>
                        <div v-if="index + 1 != ReqEventList.length">
                          <v-btn text icon @click="downData(index)"
                            ><v-icon>mdi-chevron-down</v-icon></v-btn
                          >
                        </div>
                      </td>
                      <td class="justify-center">
                        <span>{{ index + 1 }}</span>
                      </td>
                      <td class="justify-center">
                        <span>{{ rowIndex1.title }}</span>
                      </td>
                      <td class="justify-center">
                        <span>{{ rowIndex1.activeStatus }}</span>
                      </td>
                      <td class="justify-center">
                        <span>{{ rowIndex1.action }}</span>
                      </td>
                    </tr>
                  </Draggable>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
      <v-dialog v-model="dialogAdd" max-width="700px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text">จัดการระบบ</v-card-title>

          <v-card-text>
            <v-divider class="mb-4"></v-divider>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  ชื่อระบบ (ไทย)
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-text-field
                  outlined
                  dense
                  hide-details=""
                  class="align-center"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  ชื่อระบบ (Eng)
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-text-field
                  outlined
                  dense
                  hide-details=""
                  class="align-center"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  Path
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-text-field
                  outlined
                  dense
                  hide-details=""
                  class="align-center"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  Icon
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-text-field
                  outlined
                  dense
                  hide-details=""
                  class="align-center"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  ระบบ
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-select
                  dense
                  hide-details
                  :items="ReqEventList.row"
                  outlined
                ></v-select
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  Taget
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-checkbox
                  hide-details
                  label="เปิดหน้าจอใหม่"
                  v-model="checkbox"
                ></v-checkbox
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  ชื่ออ้างอิง
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-text-field
                  outlined
                  dense
                  hide-details=""
                  class="align-center"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="text-body-1 Darkgrey--text">
                  การใช้งาน
                </span>
              </v-col>
              <v-col cols="12" sm="10">
                <v-radio-group v-model="radioGroup" row>
                  <v-radio
                    v-for="n in 3"
                    :key="n"
                    :label="`Radio ${n}`"
                    :value="n"
                  ></v-radio> </v-radio-group
              ></v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn
                class="white--text mr-2"
                color="error"
                @click="dialog.visible = false"
                >ยกเลิก
              </v-btn>
              <v-btn color="success" @click="onSave">ยืนยัน</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  components: {
    Draggable
  },
  data() {
    return {
      headers: [
        {
          text: 'จัดเรียง',
          value: 'row',
          sortable: false,
          class: 'black--text grey lighten-4',
          align: 'center',
          width: '10%'
        },
        {
          text: 'ลำดับ',
          value: 'order',
          class: 'black--text grey lighten-4',
          align: 'center',
          width: '10%'
        },
        {
          text: 'รายการ',
          value: 'title',
          sortable: false,
          class: 'black--text grey lighten-4',
          align: 'center'
        },

        {
          text: 'การใช้งาน',
          value: 'activeStatus',
          sortable: false,
          class: 'black--text grey lighten-4',
          align: 'center'
        },

        {
          text: 'จัดการ',
          value: 'action',
          sortable: false,
          class: 'black--text grey lighten-4',
          align: 'center'
        }
      ],
      title: 'ข้อมูลผู้ขอทำบัตร',
      info: [],
      items: [],
      loading: false,
      dialogAdd: false,
      ReqEventList: [
        {
          row: 1,
          order: 159,
          title: 6.0,
          activeStatus: 1,
          action: 4.0
        },
        {
          row: 2,
          order: 159,
          title: 8,
          activeStatus: 2,
          action: 5
        },
        {
          row: 3,
          order: 30,
          title: 3,
          activeStatus: 3,
          action: 3
        },
        {
          row: 4,
          order: 40,
          title: 4,
          activeStatus: 4,
          action: 4
        }
      ]
      // ReqEventList: []
    }
  },

  // async mounted() {
  //   await this.initialInfo()
  // },
  computed: {
    // ReqEventList() {
    //   return [
    // {
    //   row: 1,
    //   order: 159,
    //   title: 6.0,
    //   activeStatus: 24,
    //   action: 4.0
    // },
    // {
    //   row: 2,
    //   order: 159,
    //   title: 8,
    //   activeStatus: 50,
    //   action: 5
    // },
    // {
    //   row: 3,
    //   order: 30,
    //   title: 3,
    //   activeStatus: 30,
    //   action: 3
    // }
    //   ]
    // }
  },
  methods: {
    upData(index) {
      this.ReqEventList[index] = this.ReqEventList.splice(
        index - 1,
        1,
        this.ReqEventList[index]
      )[0]
      // console.log('Up ' + JSON.stringify(this.ReqEventList))
    },
    downData(index) {
      // console.log('down ' + index)

      this.ReqEventList[index] = this.ReqEventList.splice(
        index + 1,
        1,
        this.ReqEventList[index]
      )[0]
      // console.log('down ' + JSON.stringify(this.ReqEventList))
    }
  }
}
</script>
